export enum Insight {
  moodUp = "mood-up",
  moodDown = "mood-down",
  feelingsPositive = "feelings-positive",
  feelingsNegative = "feelings-negative",
}
